import type { OverviewAdminKpisRepository } from '../../application/OverviewAdminKpisRepository'

/** Démonstration sans base seulement (jamais en repli d'une vraie) : des faux montants fausseraient une décision. */
export function createFixtureOverviewAdminKpisRepository(): OverviewAdminKpisRepository {
  return {
    load(season) {
      return Promise.resolve({
        season,
        seasons: ['2026-2027', '2025-2026'],
        computedAt: new Date().toISOString(),
        invoices: {
          invoicedCents: 14_890_260,
          toCollectCents: 10_973_137,
          overdueCents: 342_455,
          openInvoicesCount: 287,
          overdueInvoicesCount: 1,
        },
        payments: { collectedCents: 3_848_123, collectedThisMonthCents: 0 },
        contracts: {
          clientsCount: 318,
          signedCount: 290,
          signedValueCents: 15_234_000,
          activeCount: 29,
          awaitingSignatureCount: 53,
          awaitingSignatureValueCents: 2_174_000,
          vipCount: 26,
          vipValueCents: 1_293_000,
        },
        overdueInvoices: [
          {
            id: 'fixture-invoice-1',
            number: 'FAC-000612',
            dueOn: '2026-09-09',
            balanceCents: 23_685,
            contractNumber: 'CTR-260000186',
            clientName: 'Client démonstration',
          },
        ],
      })
    },
  }
}
